import { render, staticRenderFns } from "./privacy-mode.vue?vue&type=template&id=53718ab8&scoped=true&"
import script from "./privacy-mode.vue?vue&type=script&lang=ts&"
export * from "./privacy-mode.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-mode.vue?vue&type=style&index=0&id=53718ab8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53718ab8",
  null
  
)

export default component.exports